import { render, staticRenderFns } from "./GoogleLoginComponent.vue?vue&type=template&id=18c044e4&lang=pug&"
import script from "./GoogleLoginComponent.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginComponent.vue?vue&type=style&index=0&id=18c044e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports